import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingButton } from "@mui/lab";
import { useMediaQuery, useTheme } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { onAddUpdateOrderDeliveryPickupLocationError, onAddUpdateOrderDeliveryPickupLocationSuccess, } from "../../../Shared/components/AddressCard/utils/addressCardUtils";
import { usePaymentForm } from "../../../Shared/components/PaymentForm/usePaymentForm";
import useToast from "../../../hooks/useToast";
import { BillingInformationContext } from "../../BillingInformation/BillingInformationContext";
import { UpdateOrderDeliveryPickupModalContext } from "../deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { TabValues, UpdateOrderTexts } from "../deliveryModalUtils/const-enums-types";
import { updateSelectedState } from "./submitNewAddressBtn-utils";
import { usePayment } from "../../BillingInformation/Shared/hooks/Payment/usePayment";
import { useModal } from "../../../Shared/components/Modal";
import { confirmThenUpdateOrderDelivery } from "../../utils/requests";
import { PaymentFormContext } from "../../../Shared/components/PaymentForm/PaymentFormContext";
export const SubmitNewAddressBtn = ({ updateFunction, onClose, modalLoadingState, initTabProps, shouldDisplayPaymentForm, setShouldDisplayPaymentForm, refetchOrders, }) => {
    const theme = useTheme();
    const toast = useToast();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { newAddressData, setTabValue, tabValue, loading, setLoading } = useContext(UpdateOrderDeliveryPickupModalContext);
    const { giftCard, paymentMethod } = useContext(PaymentFormContext);
    const [newAddressSelected, setNewAddressSelected] = useState(false);
    const { setBalance, balance, setIsFormSubmitted, resetContext: resetPaymentFormContext } = usePaymentForm();
    const { initPayWithPaymentMethod } = usePayment();
    const { showModal } = useModal();
    const { resetContext: resetBillingInfoContext, paymentProcessor } = useContext(BillingInformationContext);
    const resetContexts = () => {
        resetBillingInfoContext();
        resetPaymentFormContext();
    };
    const confirmThenUpdate = () => confirmThenUpdateOrderDelivery(newAddressData, onAddUpdateOrderDeliveryPickupLocationSuccess, onError);
    const SWROnSuccess = onAddUpdateOrderDeliveryPickupLocationSuccess(toast, onClose, setTabValue, setBalance, setLoading, setIsFormSubmitted, showModal, confirmThenUpdate, paymentProcessor, setShouldDisplayPaymentForm, resetContexts, balance === null || balance === void 0 ? void 0 : balance.remainingBalance, paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id, initPayWithPaymentMethod, refetchOrders);
    const onError = onAddUpdateOrderDeliveryPickupLocationError(toast, setLoading, setIsFormSubmitted);
    useEffect(() => {
        let mounted = true;
        if (mounted) {
            updateSelectedState(newAddressData, initTabProps, setNewAddressSelected);
        }
        return () => {
            mounted = false;
        };
    }, [newAddressData]);
    const giftCardCoversBalance = () => { var _a; return giftCard ? ((giftCard === null || giftCard === void 0 ? void 0 : giftCard.balance) > ((_a = balance === null || balance === void 0 ? void 0 : balance.remainingBalance) !== null && _a !== void 0 ? _a : 0) ? true : false) : false; };
    return (_jsx(LoadingButton, Object.assign({ size: "medium", color: "primary", variant: "contained", fullWidth: true, sx: { width: isMobile ? undefined : theme.spacing(20.5), alignSelf: "flex-end" }, loading: loading || modalLoadingState, disabled: 
        // * If the user is on the payment form (tabValue === -1) and there is no paymentMethod, or if a new address has not been selected, the button should be disabled.
        (shouldDisplayPaymentForm && ((!paymentMethod && !giftCard) || (!paymentMethod && !giftCardCoversBalance()))) ||
            !newAddressSelected, onClick: (event) => {
            // * If there is a balance and the user is not on the payment form (tabValue === -1), the payment form should be displayed.
            if (balance && (balance === null || balance === void 0 ? void 0 : balance.remainingBalance) > 0 && tabValue !== TabValues.NONE) {
                setTabValue(TabValues.NONE); // ! This is not a valid option for the Tabs component. It needs to be handled differently.
                setShouldDisplayPaymentForm(true);
            }
            else {
                // Stops form submission from propagating up to parent components
                setLoading(true);
                setIsFormSubmitted(true);
                event.stopPropagation();
                updateFunction(newAddressData, balance, giftCard === null || giftCard === void 0 ? void 0 : giftCard.id, SWROnSuccess, onError);
            }
        } }, { children: UpdateOrderTexts.SUBMIT })));
};
